import ComponentDialog1 from './componentDialog1';
import Title from './title.vue'
import ComponentEmpty from "@/components/componentEmpty";
// 列表
import baseList from './base-list.vue';

function plugins(Vue) {
    Vue.component('ComponentDialog1', ComponentDialog1);
    Vue.component('ComponentEmpty', ComponentEmpty);
    Vue.component('Title', Title);
    Vue.component(baseList.name, baseList);
}

export default plugins;